var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CustomExchangeReveal,{attrs:{"logo":_vm.logo,"logoAlt":_vm.logoAlt,"canExchange":_setup.canExchange},on:{"close":function($event){return _setup.emit('close')},"exchange":_setup.handleExchange,"reset":_setup.reset}})
}
var staticRenderFns = []

export { render, staticRenderFns }